<template>
  <div
    @click="$emit('onClick')"
    class="cursor-pointer flex h-64"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
  >
    <div class="w-full pr-3 flex flex-wrap items-end md:items-start">
      <div class="w-full text-right">
        <p class="uppercase font-hairline">Next</p>
        <h3 class="text-xl md:text-4xl leading-none">{{project.name}}</h3>
      </div>
    </div>
    <div
      :style="{ backgroundImage: 'url(' + project.heroSrc + ')' }"
      class="bg-cover bg-center bg-no-repeat transition-all duration-500 ease-in-out"
      :class="customCss"
    >
    </div>
  </div>
</template>

<script>

export default {
  name: 'NextButton',
  props: {
    project: Object
  },
  components: {
  },
  data () {
    return {
      hovered: false
    }
  },
  computed: {
    customCss () {
      var toReturn = ''

      if (!this.hovered) {
        toReturn += ' w-16 '
      } else {
        toReturn += ' w-24 '
      }
      return toReturn
    }
  },
  methods: {
  }
}

</script>

<style lang="scss">

</style>
